import { render, staticRenderFns } from "./Umbrellas.vue?vue&type=template&id=c45885da&scoped=true&"
import script from "./Umbrellas.vue?vue&type=script&lang=ts&"
export * from "./Umbrellas.vue?vue&type=script&lang=ts&"
import style0 from "./Umbrellas.vue?vue&type=style&index=0&id=c45885da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45885da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VCard,VExpandTransition,VHover,VImg,VOverlay})
